module.exports = __webpack_public_path__ + "img/sui2.f659af94.png";